module.exports = __webpack_public_path__ + "static/media/Southern Standard Logo.f115d69a.png";